/* SKATE Club – Team-Filter (Suche, A–Z, Qualifikation, Sortierung)
   Arbeitet rein auf dem gerenderten DOM – funktioniert mit Liquid-Blöcken. */
(function(){
  document.querySelectorAll('[data-sc-team]').forEach(function(root){
    var grid=root.querySelector('[data-grid]');
    var cards=Array.prototype.slice.call(grid.querySelectorAll('.sc-coach'));
    var searchEl=root.querySelector('[data-search]');
    var sortEl=root.querySelector('[data-sort]');
    var qualEl=root.querySelector('[data-qual]');
    var alphaRow=root.querySelector('[data-alpha]');
    var resetBtn=root.querySelector('[data-reset]');
    var emptyEl=root.querySelector('[data-empty]');

    var QUAL={
      a:/A-Lizenz/i, b:/B-Lizenz/i, c:/C-Lizenz/i,
      diplom:/Diplom/i, choreo:/Choreograph/i, profi:/Profi|Eiskunstl/i
    };
    var state={q:'',letter:'',sort:'standard',qual:''};

    /* A–Z-Leiste aufbauen */
    var initials={};
    cards.forEach(function(c){initials[(c.dataset.name||'').charAt(0).toUpperCase()]=1;});
    var html='<button type="button" class="all active" data-letter="">Alle</button>';
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(function(l){
      html+='<button type="button" data-letter="'+l+'"'+(initials[l]?'':' disabled')+'>'+l+'</button>';
    });
    alphaRow.innerHTML=html;

    function apply(){
      var visible=0;
      var list=cards.slice();
      if(state.sort==='az')list.sort(function(a,b){return a.dataset.name.localeCompare(b.dataset.name,'de');});
      else if(state.sort==='za')list.sort(function(a,b){return b.dataset.name.localeCompare(a.dataset.name,'de');});
      else list.sort(function(a,b){return (+a.dataset.index)-(+b.dataset.index);});
      list.forEach(function(c,i){
        grid.appendChild(c);
        var name=(c.dataset.name||'').toLowerCase();
        var role=c.dataset.role||'';
        var show=true;
        if(state.q&&name.indexOf(state.q.toLowerCase())===-1)show=false;
        if(state.letter&&name.charAt(0).toUpperCase()!==state.letter)show=false;
        if(state.qual&&!QUAL[state.qual].test(role))show=false;
        c.style.display=show?'':'none';
        c.style.animationDelay=Math.min(i*45,400)+'ms';
        if(show)visible++;
      });
      if(emptyEl)emptyEl.style.display=visible?'none':'';
    }

    if(searchEl)searchEl.addEventListener('input',function(){state.q=searchEl.value.trim();apply();});
    if(sortEl)sortEl.addEventListener('change',function(){state.sort=sortEl.value;apply();});
    if(qualEl)qualEl.addEventListener('change',function(){state.qual=qualEl.value;apply();});
    alphaRow.addEventListener('click',function(e){
      var btn=e.target.closest('button[data-letter]');
      if(!btn||btn.disabled)return;
      state.letter=btn.dataset.letter;
      alphaRow.querySelectorAll('button').forEach(function(b){b.classList.toggle('active',b===btn);});
      apply();
    });
    if(resetBtn)resetBtn.addEventListener('click',function(){
      state={q:'',letter:'',sort:'standard',qual:''};
      if(searchEl)searchEl.value='';
      if(sortEl)sortEl.value='standard';
      if(qualEl)qualEl.value='';
      alphaRow.querySelectorAll('button').forEach(function(b){b.classList.toggle('active',b.dataset.letter==='');});
      apply();
    });

    /* Mehr lesen */
    grid.addEventListener('click',function(e){
      var btn=e.target.closest('.sc-more-btn');
      if(!btn)return;
      var card=btn.closest('.sc-coach');
      var open=card.classList.toggle('expanded');
      btn.textContent=open?'Weniger anzeigen':'Mehr lesen';
    });
  });
})();
